/**
 * @file Table/card page-size defaults and limit/offset math helpers.
 */

export const DEFAULT_TABLE_PAGE_SIZE = 50;
export const DEFAULT_CARD_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = [25, 50, 100];

export function pageCount(total, limit) {
  const lim = Math.max(1, Number(limit) || 1);
  const tot = Math.max(0, Number(total) || 0);
  if (tot === 0) return 1;
  return Math.ceil(tot / lim);
}

export function currentPage(offset, limit) {
  const lim = Math.max(1, Number(limit) || 1);
  const off = Math.max(0, Number(offset) || 0);
  return Math.floor(off / lim) + 1;
}

export function clampOffset(offset, total, limit) {
  const lim = Math.max(1, Number(limit) || 1);
  const tot = Math.max(0, Number(total) || 0);
  const off = Math.max(0, Number(offset) || 0);
  if (tot === 0) return 0;
  const maxOffset = Math.max(0, (pageCount(tot, lim) - 1) * lim);
  return Math.min(off, maxOffset);
}

export function offsetForPage(page, limit) {
  const lim = Math.max(1, Number(limit) || 1);
  const p = Math.max(1, Number(page) || 1);
  return (p - 1) * lim;
}

/**
 * Parse and clamp limit/offset from query-like values.
 * @returns {{ limit: number, offset: number }}
 */
export function parseLimitOffset(query = {}, { defaultLimit = DEFAULT_TABLE_PAGE_SIZE, maxLimit = 100 } = {}) {
  let limit = parseInt(query.limit, 10);
  if (Number.isNaN(limit) || limit < 1) limit = defaultLimit;
  limit = Math.min(limit, maxLimit);

  let offset = parseInt(query.offset, 10);
  if (Number.isNaN(offset) || offset < 0) offset = 0;

  return { limit, offset };
}
